module.exports = __webpack_public_path__ + "static/media/crossleaf.8416190d.svg";